import {isInstanceOf, isPlainObject} from 'rlink-type-utils';

/**
 * This function defines what is considered an IterableCollection
 * type.
 *
 * @param  {IterableCollection}  obj
 * @return {Boolean}
 */
export default function isIterable (obj) {
  return ( isInstanceOf(obj, Array)
      || isInstanceOf(obj, Map)
      || isInstanceOf(obj, Set)
      || isPlainObject(obj));
}



// WEBPACK FOOTER //
// ./lib/rlink-collections/core/isIterable.js